import i18n from '@/i18n'

export function promptForRequiredComment(): string | null {
	let cmt: string | null | undefined
	while (cmt === undefined) {
		cmt = prompt(i18n.global.t('willNotApplyCommentRequired'), '')

		if (cmt === null) {
			return null
		}

		cmt = cmt.trim()
		if (!cmt) {
			cmt = undefined
		}
	}

	return cmt
}
